module.exports = __webpack_public_path__ + "static/mission-img-3a25cd541d083bf7adf7c6fba1956981.png";